// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServiceLabel_wrapper__oJ6MH","title":"ServiceLabel_title__Il8nq","image":"ServiceLabel_image__Ygm5t","dark":"ServiceLabel_dark__L3Qb8","link":"ServiceLabel_link__LPftd"};